// extracted by mini-css-extract-plugin
export default {"title":"CustomModal_title__xIaPD","description":"CustomModal_description__1-rby"};